import React from "react"
import { LOCAL_STORAGE_TAGS } from "constants/index"

const TicketPeak = () => {
  const VENDOR_ID = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
  )

  return (
    <React.Fragment>
      <div className="page-content vh-100">
        <iframe
          src={
            "https://staging.ticketservices.io/box/login?enCappture-client_id=" +
            VENDOR_ID
          }
          width="100%"
          allowFullScreen={true}
          height="100%"
        ></iframe>
      </div>
    </React.Fragment>
  )
}
export default TicketPeak
